import {Button, Dropdown, Image, Modal} from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import {Link} from 'react-router-dom';
import papagalos_png from '../../images/papagalos_comic.png';
import React, {useState} from "react";
import avatar from "../../images/Profile Interface-cuate.svg"
import {logout} from "../../api/api";
import {User} from "../Login/User";
import "./navbar.css";

const MainNavBar = () => {
    const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);
    const user: User = JSON.parse(localStorage.getItem("user") || "null");

    const handleLogout = async () => {
        try {
            const response = await logout();
            if (response.status === 200) {
                localStorage.removeItem("user");
                window.location.assign("/");
            } else {
                alert("Could not log out");
            }
        } catch (error) {
            alert("An error occurred during logout");
        }
    };

    return (
        <Navbar className="custom-navbar" variant="dark" sticky="top" collapseOnSelect expand="lg">
            <Container>
                <Link to="/main" className='me-5 text-decoration-none'>
                    <Image src={papagalos_png} width={120} className="navbar-brand-img" />
                </Link>
                <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto h5">
                        <Nav.Link className='text-light nav-link-custom' href="/">Αρχική</Nav.Link>
                        <Nav.Link className='text-light nav-link-custom' href="/folder/1">Σημειώσεις</Nav.Link>
                        <Nav.Link className='text-light nav-link-custom' href="/news">Νέα</Nav.Link>
                        <Nav.Link className='text-light nav-link-custom' href="/forum">Forum</Nav.Link>
                        <Nav.Link className='text-light nav-link-custom' href="/help">Υποστήριξη</Nav.Link>
                    </Nav>
                    <Nav className="h5 align-items-center">
                        {localStorage.getItem("user") ? (
                            <>
                                <div className="text-light me-3">{user.grapes} 🍇</div>
                                <Dropdown align="end">
                                    <Dropdown.Toggle as="div" className="p-0 border-0 bg-transparent" style={{ cursor: 'pointer' }}>
                                        <Image src={avatar} width={40} height={40} roundedCircle style={{ objectFit: 'cover', border: '2px solid rgba(255,255,255,0.2)' }} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="shadow border-0 mt-2">
                                        <Dropdown.Item as={Link} to="/profile">Προφίλ</Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Item onClick={() => setShowLogoutModal(true)} className="text-danger">Αποσύνδεση</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </>
                        ) : (
                            <Nav.Link href="/login" className="text-light btn btn-outline-light rounded-pill px-4 ms-lg-3">Login</Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
                <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Αποσύνδεση</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowLogoutModal(false)}>
                            Ακύρωση
                        </Button>
                        <Button variant="danger" onClick={handleLogout}>
                            Αποσύνδεση
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>

        </Navbar>

    )
        ;
}

export default MainNavBar;